module.exports = fox._r("images/emoji/gift-112.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/emoji/gift-112.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/emoji/gift-112.png
// module id = 313
// module chunks = 4